import styled from 'styled-components';
import { device } from '../../../../ui-components/breakpoints';
import { fontWeightBold, playGrey5, regularWhite } from '../../../../ui-components/design-tokens';
import { playFontSize } from '../../../../ui-components/typography/helpers';

export const ProgramInfoContainer = styled.div`
    position: absolute;
    top: 25px;
    left: 0;
    width: 100%;
    text-align: center;
`;

export const ProgramInfoTitleContainer = styled.h1`
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    max-width: 55%;
    text-overflow: ellipsis;
    font-weight: ${fontWeightBold};
    color: ${regularWhite};
    ${playFontSize(1.8)}

    @media ${device.GteSmall} {
        ${playFontSize(2.2)};
    }
`;

export const ProgramInfoTitle = styled.span`
    text-shadow: 0 0 5px ${playGrey5};
`;
